<template>
  <div id="getStarted">
    <main class="get-started">
      <div class="row">
        <h1>{{ getTranslations.visitor_index_get_started_msg_1 }}
          <br><strong>{{ getTranslations.visitor_index_get_started_msg_2 }}</strong></h1>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="tablet"></div>
        </div>
        <div class="col-lg-6">
          <div class="row">
            <div class="prize-img">
              <img :src="getTranslations.project_config_visitor_index_get_started_prizes_img"
                   :alt="getTranslations.project_config_index_duel_prizes">
            </div>
          </div>
          <div class="row">
            <div class="button">
              <a @click.prevent="goToRegistration"
                 id="submitBtn"
                 style="cursor: pointer"
                 class="btn btn--large btn--main">
                {{ getTranslations.visitor_index_get_started }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <img :class="['get-started__free_trial ', freeTrialStripe ? '' : 'free_off']"
           :src="getTranslations.project_config_visitor_index_get_started_prizes_free_trial_img"
           alt="">
    </main>
    <main class="get-started-mobile">
      <div class="row">
        <div class="col-md-12 tablet"><img src="static/images/safari_uc.png" alt=""></div>
        <div class="col-md-12 button">
          <a @click.prevent="goToRegistration"
             id="submitBtn"
             style="cursor: pointer"
             class="btn btn--large btn--main">
            {{ getTranslations.visitor_index_get_started }}
          </a>
        </div>
        <div class="col-md-12 title">
          <h1>{{ getTranslations.visitor_index_get_started_msg_1 }}
            <br><strong>{{ getTranslations.visitor_index_get_started_msg_2 }}</strong></h1>
        </div>
        <div class="col-md-12 prize-img">
          <img :src="getTranslations.project_config_visitor_index_get_started_prizes_img"
               :alt="getTranslations.project_config_index_duel_prizes">
        </div>
      </div>
      <img :class="['get-started__free_trial ', freeTrialStripe ? '' : 'free_off']"
           :src="getTranslations.project_config_visitor_index_get_started_prizes_free_trial_img"
           alt="">
    </main>
    <simplify-registration v-if="showSimpleRegistrationModal"
                           @close="showSimpleRegistrationModal = false;">
    </simplify-registration>
    <sub-verify-wifi v-if="HE_ERROR_CODE"
                     @close="HE_ERROR_CODE = false;">
    </sub-verify-wifi>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';
import RegistrationFlowMixin from '@/common/mixins/flow';
import simplifyRegistration from '@/components/home/modals/SimplifyRegistration';
import subVerifyWifi from '@/components/home/modals/SubscriptionVerifyWifi';

export default {
  name: 'index',
  mixins: [IntegrationMixin, RegistrationFlowMixin],
  components: { simplifyRegistration, subVerifyWifi },
  data() {
    return {
      showSimpleRegistrationModal: false,
    };
  },
  created() {
    //  HE flow for TPAY
    if (this.integrationHeader === this.availableIntegrations.TPAY_EGYPT.name) {
      const locale = this.getLocale;
      let lang;
      if (locale === 'EN') {
        lang = 'en';
      } else {
        lang = locale === 'AR' ? 'ar' : 'fr';
      }
      this.$axios.get(`publicapi/loadTpayScript?lang=${lang}`).then((params) => {
        /* eslint-disable */
        let date = params.data.data.date;
        let digest = params.data.data.digest;
        sessionStorage.setItem("redirectUrl", params.data.data.redirectUrl);
        sessionStorage.setItem("can", params.data.data.customerAccountNumber);


        const url = `https://enrichment.tpay.me/idxml.ashx/v2/js?date=${date}&lang=${lang}&digest=${digest}`;

        $.get(url, function (script) {

          console.log(script);
          const scriptToAdd = document.createElement('script'); // Create <script>
          scriptToAdd.type = 'text/javascript';
          scriptToAdd.id = 'tpay_evina_script';
          const code = document.createTextNode(script); // Attach TPay JS script to <script>
          scriptToAdd.appendChild(code);
          document.head.appendChild(scriptToAdd);
          const tag = document.createElement('script');
          tag.type = 'text/javascript';
          tag.id = 'tpay_evina_exe';
          let inlineScript = document.createTextNode("var event = new Event('Call');\n" +
            "const tpay = document.getElementById('tpay_evina_script');\n" +
            "      if (tpay) {\n" +
            "          const enriched = TPay.HeaderEnrichment.enriched();\n" +
            "          console.log(enriched);\n" +
            "          if (enriched) {\n" +
            "             TPay.HeaderEnrichment.hasSubscription(\"sub_product\", \n" +
            "                 async function (result, subId) {\n" +
            "                    if (result) { \n" +
            "                       if (subId) { \n" +
            "                         console.log('subId = ', subId);\n" +
            "                         sessionStorage.setItem(\"subId\", subId);\n" +
            "                         let url = window.location.href; \n" +
            "                         (url.indexOf('?') > -1) ? url += '&' : url += '?' \n" +
            "                         url += 'hasSub=true'; \n" +
            "                         console.log('Redirecting to ', url); \n" +
            "                         window.location.href = url; \n" +
            "                         const btn = document.getElementById('submitBtn');\n" +
            "                         btn.removeAttribute('disabled');\n" +
            "                       } else { \n" +
            "                         console.log('subId is not set. continuing to current page '); \n" +
            "                         const btn = document.getElementById('submitBtn');\n" +
            "                         btn.removeAttribute('disabled');\n" +
            "                       } \n" +
            "                     } else { \n" +
            "                       const btn = document.getElementById('btn');\n" +
            "                       btn.removeAttribute('disabled');\n" +
            "                       console.log('result is: ' + result + ' continuing to current page'); \n" +
            "                     } \n" +
            "                 } \n" +
            "              );\n" +
            "          }\n" +
            "      } else {\n" +
            "          console.log(\"Error loading TPay script\");\n" +
            "      }\n");
          tag.appendChild(inlineScript);
          inlineScript = document.createTextNode("document.dispatchEvent(event);");
          tag.appendChild(inlineScript);
          document.head.appendChild(tag);
        });
      });
      /* eslint-enable */
    }
  },
  methods: {
    goToRegistration() {
      /* eslint-disable */

      if (this.integrationHeader === this.availableIntegrations.TPAY_EGYPT.name) {
        if (!TPay.HeaderEnrichment.enriched()) {
          const msisdn = TPay.HeaderEnrichment.msisdn();
          const operatorCode = TPay.HeaderEnrichment.operatorCode();
          sessionStorage.setItem('msisdn', msisdn);
          sessionStorage.setItem('operatorCode', operatorCode);
          if (sessionStorage.getItem('hasTpaySub') === true || sessionStorage.getItem('hasTpaySub') === 'true') {
            this.$axios.get(`/api/tpayAutologin?msisdn=${msisdn}&opCode=${operatorCode}`).then((response) => {
              console.log(response);
            });
          } else {
            const obj = {
              msisdn: msisdn,
              subscriptionPlanId: '1975',
              productCatalog: 'Play_and_win',
              productSku: 'Play_Win',
              operatorCode: operatorCode,
              customerAccountNumber: sessionStorage.getItem('can'),
              redirectURL: sessionStorage.getItem("redirectUrl"),
            };
            console.log('Confirm return obj = ', obj);

            try {
              TPay.HeaderEnrichment.confirm(obj,
                async function (status, refCode, contract) {
                  console.log('status: ' + status + ' refcode: ' + refCode + ' contract: ' + contract);
                  if (status === true) { // No error or fail case
                    if (contract) { // Redirection Flow
                      return contract;
                    }
                    if (refCode) { // HE Flow
                      const msisdnHE = sessionStorage.setItem('msisdn', TPay.HeaderEnrichment.msisdn());
                      const opCodeHE = sessionStorage.setItem('operatorCode', TPay.HeaderEnrichment.operatorCode());
                      const sessionToken = await TPay.HeaderEnrichment.sessionToken();
                      sessionStorage.setItem('sessionToken', sessionToken);
                      console.log('Got msisdnHE: ', msisdnHE, ' opCodeHE: ', opCodeHE, ' sessionToken: ', sessionToken);
                      this.$axios.get(`/api/addContractRequest?msisdn=${msisdnHE}&operator=${opCodeHE}&lang=${this.getLocale}`).then((res) => {
                        console.log(res);
                      });
                    }
                    // For Wifi flow, proceeds to Register1 w/ Operator Selection Modal
                  } else {
                    console.log('Status returned with: ', status);
                    location.reload(); // If status is 'error' or 'false' then reload
                  }
                }
              );

            } catch (error) {
              console.error(error);
            }
          }
        }
      }
      /* eslint-disable */
      if (!this.hasWebRegister()) {
        this.showSimpleRegistrationModal = true;
      } else {
        this.registrationRedirect();
      }
    },
  },
  computed: {
    ...mapState('common', [
      'freeTrialStripe',
      'integrationHeader',
      'availableIntegrations',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/Index.vue